import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const MobileCheckoutBar = ({
  total,
  to,
  onClick,
  buttonLabel = "Proceed to checkout",
  loading = false,
  disabled = false,
  paymentOptions = [],
  selectedPayment = "",
  onPaymentChange = () => {},
}) => {
  const [showPayments, setShowPayments] = useState(false);
  const navigate = useNavigate();

  const selectedLabel = paymentOptions.find(
    (option) => option.value === selectedPayment,
  )?.label;

  return (
    <div className="mobile-checkout-bar d-lg-none">
      <div className="d-flex align-items-center justify-content-between w-100">
        <span className="text-gray-900 fw-semibold text-base">Total</span>
        <span className="text-gray-900 fw-bold text-lg">₹{total}</span>
      </div>

      {paymentOptions.length > 0 && (
        <div className="mobile-checkout-bar__payments">
          <button
            type="button"
            className="mobile-checkout-bar__payments-toggle"
            onClick={() => setShowPayments((prev) => !prev)}
            aria-expanded={showPayments}
          >
            <span className="mobile-checkout-bar__payments-label">
              <i className="ph ph-wallet" />
              <span>Payment Method</span>
            </span>
            <span className="mobile-checkout-bar__payments-selected">
              {selectedLabel}
              <i
                className={`ph ${
                  showPayments ? "ph-caret-up" : "ph-caret-down"
                }`}
              />
            </span>
          </button>
          <div
            className={`mobile-checkout-bar__payments-list ${
              showPayments ? "is-open" : ""
            }`}
          >
            <div className="mobile-checkout-bar__payments-inner">
              {paymentOptions.map((option) => (
                <button
                  key={option.value}
                  type="button"
                  onClick={() => {
                    onPaymentChange(option.value);
                    setShowPayments(false);
                  }}
                  className={`mobile-checkout-bar__payment-option ${
                    selectedPayment === option.value ? "is-active" : ""
                  }`}
                >
                  <i className={option.icon} />
                  <span className="flex-grow-1 text-start">
                    {option.label}
                  </span>
                  <i
                    className={`ph ${
                      selectedPayment === option.value
                        ? "ph-check-circle-fill"
                        : "ph-circle"
                    }`}
                  />
                </button>
              ))}
            </div>
          </div>
        </div>
      )}

      <div className="d-flex align-items-center gap-10">
        {to ? (
          <button
            type="button"
            onClick={() => navigate("/")}
            aria-label="Go to home"
            title="Home"
            className="btn rounded-8 px-16 py-14 flex-shrink-0 d-flex align-items-center justify-content-center bg-main-50 text-main-700 hover-bg-main-600 hover-text-white border border-main-200"
            style={{ boxShadow: "0 2px 8px rgba(26, 107, 48, 0.12)" }}
          >
            <i className="ph ph-house" style={{ fontSize: "1.15rem" }} />
          </button>
        ) : (
          <button
            type="button"
            onClick={() => navigate(-1)}
            aria-label="Go back"
            title="Back"
            className="btn rounded-8 px-16 py-14 flex-shrink-0 d-flex align-items-center justify-content-center bg-main-50 text-main-700 hover-bg-main-600 hover-text-white border border-main-200"
            style={{ boxShadow: "0 2px 8px rgba(26, 107, 48, 0.12)" }}
          >
            <i className="ph ph-arrow-left" style={{ fontSize: "1.15rem" }} />
          </button>
        )}
        {to ? (
          <Link to={to} className="btn btn-main w-100 rounded-8 py-14">
            {loading ? (
              <span className="spinner-border spinner-border-sm" aria-hidden="true" />
            ) : (
              buttonLabel
            )}
          </Link>
        ) : (
          <button
            type="button"
            onClick={onClick}
            disabled={disabled || loading}
            className="btn btn-main w-100 rounded-8 py-14"
          >
            {loading ? (
              <span className="spinner-border spinner-border-sm" aria-hidden="true" />
            ) : (
              buttonLabel
            )}
          </button>
        )}
      </div>
    </div>
  );
};

export default MobileCheckoutBar;
